wbApp.controller('ReservationsCtrl', ['$scope', '$modal', '$q', '$timeout', 'tenantSettingSvc',
    'classroomSvc', 'reservationsSvc', 'domainsSvc', 'employeeSvc', 'securitySvc', 'notificationSvc', 'urlUtils', 'onlinePaymentsSvc',
'messageBoxSvc',
function ($scope, $modal, $q, $timeout, tenantSettingSvc, classroomSvc, reservationsSvc, domainsSvc, employeeSvc, securitySvc, 
          notificationSvc, urlUtils, onlinePaymentsSvc, messageBoxSvc) {

    $scope.isBusy = true;
    $scope.tenantSettings = tenantSettingSvc.settings;

    var resources = classroomSvc.getAllActiveAsync( /* classroomIDtoInclude */ null, /* filterForReservations */ true, /* filterForCourses */ false);
    var domains = domainsSvc.getAllExpandedWithClientModel();
    var employeesPromise = employeeSvc.getAll();
    var employees = [];   
    $scope.filteredEmployees = [];
    
    let selectedPlaceObj = null;
    let selectedDomainObj = null;

    $scope.selectedPlace = null;
    
    function findDomainById(domains, id) {
        let result = null;
        _.forEach(domains, function (d) {
            if (d.id === id) {
                result = d;
            }

            _.forEach(d.specializations, function (s) {
                if (s.id === id) {
                    if (!result) {
                        result = d;
                    }
                }
            });
        });
        return result;
    }

    function convertDomainSelection(domains, includeNames) {
        var domainsFilter = [];

        _.forEach(domains, function (d) {
            var domain = null;
            if (_.indexOf($scope.selectedDomains, d.id) != -1) {
                domain = {
                    id: d.id,
                    specializations: []
                };
                if (includeNames) {
                    domain.name = d.name;
                }
                domainsFilter.push(domain);
            }

            _.forEach(d.specializations, function (s) {
                if (_.indexOf($scope.selectedDomains, s.id) != -1) {
                    if (!domain) {
                        domain = {
                            id: d.id,
                            specializations: []
                        };
                        if (includeNames) {
                            domain.name = d.name;
                        }
                        domainsFilter.push(domain);
                    }

                    var specialization = {
                        id: s.id
                    };
                    if (includeNames) {
                        specialization.name = s.name;
                    };
                    domain.specializations.push(specialization);
                }
            });
        });

        return domainsFilter;
    }

    function loadAvailability(domainsChangeOnly) {

        $scope.filteredEmployees = [];

        if (!$scope.selectedPlace || !$scope.selectedDomains.length) {
            $scope.schedulerSettings.availability = [];
            if (!$scope.selectedPlace) {
                $scope.schedulerSettings.actions = [];
            }
        } else {
            var domainsFilter = convertDomainSelection(domains);
            $scope.isBusy = true;

            var promisses = [];

            promisses.push(classroomSvc.availabilityByDomainsAndRange(
                $scope.selectedPlace,
                domainsFilter,
                $scope.schedulerSettings.startDate));

            if (!domainsChangeOnly && securitySvc.isAuthenticated()) {
                promisses.push(reservationsSvc.getAllByRangeAndUser(
                    securitySvc.loggedInUser().userID,
                    $scope.schedulerSettings.startDate,
                    moment($scope.schedulerSettings.startDate).add(7, 'day').toDate(),
                    employees));
            }

            $q.all(promisses).then(
                function (data) {
                    $scope.schedulerSettings.availability = data[0];
                    if (data.length > 1) {
                        $scope.schedulerSettings.actions = data[1];
                    }
                    $scope.isBusy = false;
                },
                function (error) {
                    $scope.isBusy = false;
                }
            );
        }
    }

    var domainsDataSource = new DevExpress.data.DataSource({
        load: function (loadOptions) {
            return domains.$promise;
        },
        byKey: function (e) {
            return $q(function (resolve, reject) {
                domains.$promise.then(function (data) {
                    _.forEach(data, function (d) {
                        if (d.id == e) {
                            resolve(d);
                            return d;
                        }

                        var found = false;
                        _.forEach(d.specializations, function(s) {
                            if (s.id == e) {
                                resolve(s);
                                found = true;
                                return s;
                            }
                        })

                        if (found) {
                            return;
                        }
                    });
                },
                function(error) {
                    reject(error);
                })
            })           
        },
        loadMode: 'processed'
    });

    var placesDataSource = new DevExpress.data.DataSource({
        paginate: false,
        load: function (loadOptions) {            
            return resources.$promise;            
        },
        byKey: function (e) {
            return $q(function (resolve, reject) {
                resources.$promise.then(function (data) {
                    var item = _.find(data, { id: e });
                    resolve(item);
                },
                function (error) {
                    reject(error);
                })
            })
        },
        loadMode: 'processed'
    });

    function loadPlaceReservationSetting() {
        
        $scope.schedulerSettings.startTimeType = 
            selectedDomainObj?.reservationStartTimeType || 
            selectedPlaceObj?.reservationStartTimeType;
        
        $scope.schedulerSettings.scale = selectedPlaceObj?.reservationsSchedulerScale;
        
        $scope.schedulerSettings.selectByBlocks =
            selectedDomainObj?.reservationsSchedulerSelectByBlocks ||    
            selectedPlaceObj?.reservationsSchedulerSelectByBlocks;
        
        $scope.schedulerSettings.maximumSelectedBlocks =
            selectedDomainObj?.reservationsSchedulerMaximumSelectedBlocks ||    
            selectedPlaceObj?.reservationsSchedulerMaximumSelectedBlocks; 
    }


    $q.all([resources.$promise, domains.$promise, employeesPromise]).then(
        function (data) {
            $scope.isBusy = false;
            if (resources.length > 0) {

                $scope.selectedPlace = resources[0].id;
                selectedPlaceObj = resources[0];
                loadPlaceReservationSetting();
            }
            if (domains.length > 0) {
                let selectableDomain = domainsSvc.findFirstSelectable(domains);
                $scope.selectedDomains = !!selectableDomain 
                    ? [selectableDomain.id]
                    : [];
                selectedDomainObj = selectableDomain;
                loadPlaceReservationSetting();
            }
            employees = data[2];            
        }, function (error) {
            $scope.isBusy = false;
        }
    );

    var showReservationConfirmDialog = function(startDate, endDate, event)
    {
        reservationConfirmModalPromise.$promise.then(function () {
            reservationConfirmModalPromise.$scope.filteredEmployees = $scope.filteredEmployees;
            reservationConfirmModalPromise.$scope.startDate = startDate;
            reservationConfirmModalPromise.$scope.endDate = endDate;
            reservationConfirmModalPromise.$scope.place = _.find(resources, { id: $scope.selectedPlace });
            reservationConfirmModalPromise.$scope.domain = convertDomainSelection(domains, true);
            reservationConfirmModalPromise.$scope.onSave = function (data) {
                loadAvailability();
            };
            reservationConfirmModalPromise.show();
        });
    }

    $scope.employeeScollViewOptions = {
        height: 160,
        width: 580,
        direction: "horizontal",
        scrollByContent: true,
        scrollByThumb: true,
        showScrollbar: 'onHover'
    }

    $scope.schedulerSettings = {
        weekView: true,
        autoHourRange: false, // TODO
        visibleResources: 1,
        selectedResourceID: $scope.selectedPlace,
        startHour: tenantSettingSvc.settings.scheduleVisibleTimeStart,
        endHour: tenantSettingSvc.settings.scheduleVisibleTimeEnd,
        startDate: moment().startOf('isoWeek').toDate(),
        resources: resources,
        resourcesMapping: { resourceID: 'id' },
        actions: [],
        scale: 30,
        selectByBlocks: 2,
        maximumSelectedBlocks: 4,
        showWeekend: true,
        availability: [],
        actionsMapping: {
            resourceID: 'placeId',
            name: 'subject',
            teacher: 'teacherName',
            filled: 'filledCapacity'
        },
        commands: [{
            text: 'Vytvořit rezervaci',
            callback: function (event, startDate, endDate) {
                if (securitySvc.isAuthenticated()) {
                    $scope.onSelectionChanged({startDate: startDate, endDate: endDate });
                    showReservationConfirmDialog(startDate, endDate, event);
                } else {
                    notificationSvc.advertiseLogin();
                }
            }
        }]
    }

    $scope.onActionClicked = function (reservation) {

    }

    $scope.onSelectionChanged = function (selection) {
        let selectionStart = moment(selection.startDate);
        let selectionEnd = moment(selection.endDate);

        let filteredAvailability = _.filter(
            $scope.schedulerSettings.availability,
            function(a) {
                return selectionStart.isBefore(a.end) && selectionEnd.isAfter(a.start);
            });

        let filteredEmployeeIds = _.uniq(_.flatMap(
            filteredAvailability,
            function (d) {
                return d.employeeIds;
            }));

        $scope.filteredEmployees = _.filter(
            employees,
            function (e) {
                return _.includes(filteredEmployeeIds, e.id);
            });
    }

    $scope.calendarOptions = {        
        value: $scope.schedulerSettings.startDate,
        onValueChanged: function (e) {
            var startOfWeek = moment(e.value).startOf('isoWeek').toDate();
            if (!moment($scope.schedulerSettings.startDate).isSame(startOfWeek)) {
                $scope.schedulerSettings.startDate = startOfWeek;
                loadAvailability();
            }
        }
    }

    $scope.placeSelectBox = {
        bindingOptions: {
            value: 'selectedPlace'
        },
        valueExpr: "id",
        displayExpr: "name",
        dataSource: placesDataSource,
        onValueChanged: function (e) {

            if ($scope.schedulerSettings.selectedResourceID != e.value)
            {
                $scope.schedulerSettings.selectedResourceID = e.value;

                let place = _.find(resources, { id: e.value });
                if (!!place) {
                    selectedPlaceObj = place;
                    loadPlaceReservationSetting();
                }
                
                loadAvailability();
            }
        }
    }

    $scope.selectedDomains = [];

    var treeView = null;

    var getSelectedItemsKeys = function (items) {
        var result = [];
        items.forEach(function (item) {
            if (item.selected) {
                result.push(item.key);
            }
            if (item.items.length) {
                result = result.concat(getSelectedItemsKeys(item.items));
            }
        });
        return result;
    };

    var syncTreeViewSelection = function (treeView) {
        if (!treeView) return;

        if (!$scope.selectedDomains) {
            treeView.unselectAll();
            return;
        }

        $scope.selectedDomains.forEach(function (key) {
            treeView.selectItem(key);
        });
    };

    $scope.domainsBoxOptions = {
        dataSource: domainsDataSource,
        bindingOptions: {
            value: 'selectedDomains'            
        },
        valueExpr: "id",
        displayExpr: "fullName",
        dropDownOptions: {
            height: '300px',
            resizeEnabled: true
        },
        showClearButton: false,
        onValueChanged: function () {
            syncTreeViewSelection(treeView);
        },
        treeView: {            
            dataSource: domainsDataSource,
            dataStructure: "tree",
            keyExpr: 'id',
            itemsExpr: 'specializations',
            displayExpr: "name",
            disabledExpr: "disabledForClients",
            selectByClick: true,
            selectNodesRecursive: false,
            selectionMode: "single",
            onContentReady: function (e) {
                treeView = e.component;

                syncTreeViewSelection(treeView);
            },
            onItemSelectionChanged: function (args) {
                let nodes = args.component.getNodes();

                $scope.selectedDomains = getSelectedItemsKeys(nodes);
                let domain = findDomainById(domains, $scope.selectedDomains[0]);
                if (!!domain) {
                    selectedDomainObj = domain;
                    loadPlaceReservationSetting();
                }
                
                loadAvailability(true);
            }
        }
    }

    var reservationConfirmModalPromise = $modal({
        templateUrl: 'reservations/confirm-reservation-dialog.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    function showOnlinePaymentResultsIfNeeded() {
        var onlinePaymentIDStr = urlUtils.getQueryParams()['onlinePaymentID'];
        if (!!onlinePaymentIDStr) {
            var onlinePaymentID = Number(onlinePaymentIDStr);

            onlinePaymentsSvc.getTransactionState(onlinePaymentID).$promise.then(
                function (data) {
                    messageBoxSvc.showMessageDlg({
                        title: 'TXT_PAYMENT_RESULT',
                        message: onlinePaymentsSvc.getOnlinePaymentResultMessage(data),
                        buttons: [{
                            text: 'TXT_BTN_OK',
                            callback: function () {
                                urlUtils.removeUrlParam('onlinePaymentID');
                            }
                        }]
                    });
                });
        }
    }

    showOnlinePaymentResultsIfNeeded();
}]);